import callApiService from './api-service'
import Api from './base-api'

export default {
  login: Api.login,
  callApiService
}
